import { get, post } from "../GenericServices";

const ProjectDashboard = {
  getDataPerformance: (id) => {
    return get(`project/${id}/dashboard/performance`);
  },
  getDataCashFlow: (id) => {
    return get(`project/${id}/dashboard/cash-flow`);
  },
  downloadPerformance: (id) => {
    return get(`project/${id}/dashboard/performance/export`);
  },
  saveDataPerformance: (id, data) => {
    return post(`project/${id}/dashboard/performance/save`, data);
  },
};

export default ProjectDashboard;
